export const PROTECT_WELCOME_CTA_CLICK = 'CS/PROTECT_WELCOME_CTA_CLICK';
export const PROTECT_EMAIL_VERIFY_CLICK = 'CS/PROTECT_EMAIL_VERIFY_CLICK';
export const PROTECT_BENEFITS_CLICK = 'CS/PROTECT_BENEFITS_CLICK';
export const PROTECT_PAYMENT_SUCCESS_CLICK = 'CS/PROTECT_PAYMENT_SUCCESS_CLICK';
export const PROTECT_ACTION_OPENED = 'CS/PROTECT_ACTION_OPENED';
export const PROTECT_BREACH_DRAWER_OPENED = 'CS/PROTECT_BREACH_DRAWER_OPENED';
export const PROTECT_BREACH_DRAWER_CLOSED = 'CS/PROTECT_BREACH_DRAWER_CLOSED';
export const PROTECT_INFO_DRAWER_OPENED = 'CS/PROTECT_INFO_DRAWER_OPENED';
export const PROTECT_REALTIME_UPGRADE_CLICKED = 'CS/PROTECT_REALTIME_UPGRADE_CLICKED';
export const PROTECT_MORE_BUTTON_CLICKED = 'CS/PROTECT_MORE_BUTTON_CLICKED';
export const PROTECT_REMIND_ME_LATER_CLICKED = 'CS/PROTECT_REMIND_ME_LATER_CLICKED';
